import { claimStorefrontSession, getStorefrontAnalyticsSink, recordStorefrontSessionStart } from "@/domain/storefront-analytics";
import { getMerchantId } from "@/lib/company-storage";
import { useEffect } from "react";

/**
 * Starts the current merchant's storefront-analytics sink (periodic flush +
 * hide/unload flush) once per app session and records `session_start`.
 * Mounted once in `HydratedShell`, next to `useSuggestionEventsFlush`.
 */
export function useStorefrontAnalyticsFlush(): void {
  useEffect(() => {
    const merchantId = getMerchantId();
    if (!merchantId) return;
    recordStorefrontSessionStart();
    claimStorefrontSession();
    return getStorefrontAnalyticsSink(merchantId).start();
  }, []);
}
